import { SearchIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";
import ContactList from "../contact/ContactList";
import { useAuth } from "../../context/AuthContext";
import { ApiResponse } from "../../api/apiResponse";
import { getContacts } from "../../api/endpoints/chat/conversations";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import useSearch from "../../hooks/useSearch";
type contactWrapperProps = {
  updateConversationList?: (id: string | number) => void;
  refetchConversations?: () => void;
};
export default function ContactsWrapper(props: contactWrapperProps) {
  const { updateConversationList, refetchConversations } = props;
  const { t } = useTranslation("", {
    keyPrefix: "page.chat",
  });
  const { currentUser }: any = useAuth();
  const [contactList, setContactsList] = useState([]);
  const { onSearch } = useSearch();
  const [contactListCopy, setContactsListCopy] = useState([]);

  const getContactsList = async () => {
    const response: ApiResponse = await getContacts({
      ActorId: currentUser?.id,
      ActorType: currentUser?.object_type,
    });
    if (response.isSuccess) {
      const { data } = response;
      setContactsList(data ?? []);
      setContactsListCopy(data ?? []);
    } else {
      response.errorMessages.forEach((errorMessage) => {
        toast.error(errorMessage);
      });
    }
  };
  useEffect(() => {
    if (currentUser?.object_type?.toLowerCase() !== "candidate") {
      getContactsList();
    }
  }, []);

  const searchParticipants = (val: string) => {
    let dataContacts = onSearch(val, contactListCopy);
    setContactsList(dataContacts);
  };

  return (
    <div className="w-full ">
      <div className="flex flex-col gap-[18px] px-[21px] py-7 border-b border-gray-300">
        <h2 className="text-lg leading-6 font-medium text-gray-900">
          {t("contacts")}
        </h2>
        <div className="relative rounded-md shadow-sm">
          <div className="absolute inset-y-0 start-0 ps-3  flex items-center pointer-events-none">
            <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
          <input
            type="text"
            name="search"
            id="search"
            className="block w-full ps-10 border border-gray-300 focus:ring-brandblue-500 focus:border-brandblue-500 text-sm rounded-md"
            placeholder={t("searchByName")}
            onChange={(e) => {
              searchParticipants(e.target.value);
            }}
          />
        </div>
      </div>

      <ContactList
        updateConversationList={updateConversationList}
        contactList={contactList}
        refetchConversations={refetchConversations}
      />
    </div>
  );
}
